module.exports = __webpack_public_path__ + "static/merchant-campaign-promotional-sp-126612f164bfbe0bc80a4b59fdb0f338.png";